import { Box, styled } from '@mui/material';

const Grid = styled(Box)`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(96px, 1fr));
  gap: 4px;
`;

export default Grid;
